import React, { useEffect, useRef, useState } from "react";
import { useSlate } from "slate-react";
import Button from "./ToolbarItems/Button";
import {
  toggleBlock,
  toggleMark,
  isMarkActive,
  addMarkData,
  isBlockActive,
  activeMark,
} from "./utils/SlateUtilityFunctions";
import defaultToolbarGroups from "./ToolbarItems/toolbarGroups";
import useTable from "./utils/useTable";
import { BsTypeH1, BsTypeH2, BsTypeH3 } from "react-icons/bs";
import ColorPicker from "./ToolbarItems/ColorPicker";
import {
  FiAlignCenter,
  FiAlignJustify,
  FiAlignLeft,
  FiAlignRight,
  FiBold,
  FiItalic,
  FiList,
  FiUnderline,
} from "react-icons/fi";
import { CiLineHeight } from "react-icons/ci";
import { RxLetterSpacing } from "react-icons/rx";

import { AiOutlineOrderedList } from "react-icons/ai";
import useOnClickOutside from "../../../../utils/useOnClickOutside";

const Toolbar = ({ setOpen }: any) => {
  const editor = useSlate();
  const isTable = useTable(editor);
  const ref = useRef(null);
  const [toolbarGroups, setToolbarGroups] = useState(defaultToolbarGroups);

  useOnClickOutside(ref, (event) => {
    setOpen(event);
  });

  useEffect(() => {
    let filteredGroups = [...defaultToolbarGroups];
    if (isTable) {
      filteredGroups = toolbarGroups.map((grp) =>
        grp.filter((element) => element.type !== "block")
      );
      filteredGroups = filteredGroups.filter((elem) => elem.length);
    }
    setToolbarGroups(filteredGroups);
  }, []);

  const BlockButton = ({ format, Icon }: any) => {
    return (
      <Button
        active={isBlockActive(editor, format)}
        format={format}
        onMouseDown={(e: any) => {
          e.preventDefault();
          setTimeout(() => {
            toggleBlock(editor, format);
          }, 100);
        }}
      >
        {Icon && <Icon className="text-2xl" />}
      </Button>
    );
  };
  const MarkButton = ({ format, Icon }: any) => {
    return (
      <Button
        active={isMarkActive(editor, format)}
        format={format}
        onMouseDown={(e: any) => {
          e.preventDefault();
          setTimeout(() => {
            toggleMark(editor, format);
          }, 100);
        }}
      >
        {Icon && <Icon className="text-2xl" />}
      </Button>
    );
  };
  const Dropdown = ({ format, options, title, Icon }: any) => {
    return (
      <div className="my-2 text-left">
        <p className="text-gray-600 mb-1  text-sm font-semibold">{title}</p>
        <div className="flex">
          {Icon && <Icon className="text-2xl" />}
          <select
            className="w-full"
            value={activeMark(editor, format)}
            onChange={(e) => {
              changeMarkData(e, format);
            }}
          >
            {options.map((item: any, index: number) => (
              <option key={index} value={item.value}>
                {item.text}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  };

  const FontSize = ({ format, options }: any) => {
    const add = () => {
      const value = (parseInt(activeMark(editor, format), 10) || 16) + 1;
      addMarkData(editor, { format, value });
    };
    const substract = () => {
      const value = (parseInt(activeMark(editor, format), 10) || 16) - 1;
      addMarkData(editor, { format, value });
    };
    return (
      <div className="flex">
        <button onClick={substract}>-</button>
        {activeMark(editor, format)}
        <button onClick={add}>+</button>

        {/* <select
        value={activeMark(editor, format)}
        onChange={(e) => changeMarkData(e, format)}
      >
        {options.map((item, index) => (
          <option key={index} value={item.value}>
            {item.text} -
          </option>
        ))}
      </select> */}
      </div>
    );
  };
  const changeMarkData = (event: any, format: any) => {
    event.preventDefault();
    const value = event.target.value;
    addMarkData(editor, { format, value });
  };

  return (
    <div ref={ref} className=" fixed left-0 top-16 bg-white w-80 z-10 h-full">
      <div className=" px-4 py-2 w-full">
        <Dropdown
          format="fontFamily"
          title="Tipografía"
          options={[
            { text: "Default", value: `` },
            { text: "Auckland Hills", value: "AucklandHills" },
          ]}
        />
        <hr />
        <div className="flex gap-5">
          <div className="w-full">
            <Dropdown
              format="weight"
              title="Peso"
              options={[
                { text: "Default", value: `` },
                { text: "Ligth", value: "300" },
                { text: "Normal", value: "400" },
                { text: "Semibold", value: "600" },
                { text: "Bold", value: "700" },
                { text: "Bolder", value: "800" },
              ]}
            />
          </div>
          <div
            className="border-gray-300 border-r h-14 pt-1"
            style={{ width: "1px" }}
          ></div>
          <div className="w-full">
            <Dropdown
              format="fontSize"
              title="Tamaño"
              options={[
                { text: "Default", value: "" },
                { text: "8px", value: "8px" },
                { text: "10px", value: "10px" },
                { text: "11px", value: "11px" },
                { text: "12px", value: "12px" },
                { text: "14px", value: "14px" },
                { text: "16px", value: "16px" },
                { text: "18px", value: "18px" },
                { text: "20px", value: "20px" },
                { text: "22px", value: "22px" },
                { text: "24px", value: "24px" },
                { text: "26px", value: "26px" },
                { text: "28px", value: "28px" },
                { text: "36px", value: "36px" },
                { text: "48px", value: "48px" },
                { text: "72px", value: "72px" },
              ]}
            />
          </div>
        </div>
        <hr />

        <div className="flex gap-5">
          <div className="w-full">
            <Dropdown
              format="lineHeight"
              title="Espaciado"
              Icon={CiLineHeight}
              options={[
                { text: "Default", value: "" },
                { text: "8px", value: "8px" },
                { text: "10px", value: "10px" },
                { text: "11px", value: "11px" },
                { text: "12px", value: "12px" },
                { text: "14px", value: "14px" },
                { text: "16px", value: "16px" },
                { text: "18px", value: "18px" },
                { text: "20px", value: "20px" },
                { text: "22px", value: "22px" },
                { text: "24px", value: "24px" },
                { text: "26px", value: "26px" },
                { text: "28px", value: "28px" },
                { text: "36px", value: "36px" },
                { text: "48px", value: "48px" },
                { text: "72px", value: "72px" },
              ]}
            />
          </div>
          <div
            className="border-gray-300 border-r h-14"
            style={{ width: "1px" }}
          ></div>
          <div className="w-full">
            <Dropdown
              format="letterSpacing"
              title="E. fuente"
              Icon={RxLetterSpacing}
              options={[
                { text: "Default", value: "" },
                { text: "-4px", value: "-4px" },
                { text: "-3px", value: "-3px" },
                { text: "-2px", value: "-2px" },
                { text: "-1px", value: "-1px" },
                { text: "1px", value: "1px" },
                { text: "2px", value: "2px" },
                { text: "3px", value: "3px" },
                { text: "5px", value: "4px" },
                { text: "5px", value: "5px" },
                { text: "6px", value: "6px" },
                { text: "7px", value: "7px" },
                { text: "8px", value: "8px" },
                { text: "5px", value: "5px" },
                { text: "6px", value: "6px" },
                { text: "7px", value: "7px" },
                { text: "8px", value: "8px" },
                { text: "10px", value: "10px" },
                { text: "11px", value: "11px" },
                { text: "12px", value: "12px" },
                { text: "14px", value: "14px" },
                { text: "16px", value: "16px" },
                { text: "18px", value: "18px" },
                { text: "20px", value: "20px" },
                { text: "22px", value: "22px" },
                { text: "24px", value: "24px" },
                { text: "26px", value: "26px" },
                { text: "28px", value: "28px" },
              ]}
            />
          </div>
        </div>

        <hr />
        <div className="text-left mt-2">
          <p className="text-sm font-semibold mb-1">Tipo de texto</p>
          <div className="flex">
            <BlockButton format="headingOne" Icon={BsTypeH1}></BlockButton>
            <BlockButton format="headingTwo" Icon={BsTypeH2} />
            <BlockButton format="headingThree" Icon={BsTypeH3} />
            <div
              className="border-r border-gray-300 h-5 mx-2"
              style={{ width: "1px" }}
            ></div>
            <MarkButton format="bold" Icon={FiBold} />
            <MarkButton format="italic" Icon={FiItalic} />
            <MarkButton format="underline" Icon={FiUnderline} />
          </div>
        </div>
      </div>

      <div className="gap-4 border-t border-gray-400">
        <div className="px-4 py-3 flex gap-1">
          <BlockButton format="alignLeft" Icon={FiAlignLeft} />
          <BlockButton format="alignCenter" Icon={FiAlignCenter} />
          <BlockButton format="alignRight" Icon={FiAlignRight} />
          <BlockButton
            format="justify"
            Icon={FiAlignJustify}
            style={{ width: "1px" }}
          />
          <div
            className="border-r border-gray-300  mx-2"
            style={{ width: "1px" }}
          ></div>
          <BlockButton format="orderedList" Icon={FiList} />
          <BlockButton format="unorderedList" Icon={AiOutlineOrderedList} />
        </div>
      </div>
      <div className=" px-4 py-4 border-t border-gray-300">
        <ColorPicker activeMark={activeMark} format="color" editor={editor} />
      </div>
    </div>
  );
};

export default Toolbar;
